'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { FillScreen } from '@/components/Layout';
import { RuleAndPolicyResourceSidebar } from './-components/RuleAndPolicyResourceSidebar';
export const Route = createFileRoute('/_staff/equipment/_layout/rule-and-policy/_layout')({
  component: RuleAndPolicyLayout
});
function RuleAndPolicyLayout() {
  return <FillScreen className="flex">
      <RuleAndPolicyResourceSidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Outlet />
      </div>
    </FillScreen>;
}